import clsx from 'clsx';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      className={clsx('size-8 shrink-0', className)}
    >
      <rect width="64" height="64" rx="16" fill="#0A0A0A" />
      <path
        d="M32 10 52 28 32 54 12 28 32 10Z"
        fill="#0F2F2B"
        stroke="#2DD4BF"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M21 36c6-4 16-4 22 0"
        fill="none"
        stroke="#F8FAFC"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M22 24c5 3 5 11 0 15M42 24c-5 3-5 11 0 15"
        fill="none"
        stroke="#FB7185"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function Logo({ className }: { className?: string }) {
  return (
    <span className={clsx('inline-flex items-center gap-2 font-semibold', className)}>
      <LogoMark />
      <span className="hidden min-[360px]:inline">BaseballSTRM</span>
      <span className="min-[360px]:hidden">STRM</span>
    </span>
  );
}
